import React, {useEffect, useState} from 'react';
import TrackingTable, {OrderBaseItem} from "./components/TrackingTablePage";
import {TrackingTableTitle} from "../../../enums/DeliveryTrackingTableEnum";
import {useDeliveryTaskOrderList, useExceptionDictionaries} from '../store/deliveryStore';
import {t} from "../../../i18n";
import {useTranslation} from "react-i18next";
import { getExceptionTypeText } from '../../../utils/i18nUtils';

interface ReturnToWarehouseProps {}
const ReturnToWarehousePage: React.FC<ReturnToWarehouseProps> = () => {
    const {i18n} = useTranslation();
    const [returnToWarehouseData,setReturnToWarehouseData] = useState<OrderBaseItem[]>([]);
    const {deliveryTaskOrderList: deliveringTasks} = useDeliveryTaskOrderList();
    const exceptionDictionaries = useExceptionDictionaries();
    useEffect(() => {
        if (!deliveringTasks.length) return;
        const returnToWarehouse =
            deliveringTasks.filter(item => item?.isPickedUp && item.isAbnormal && !item.isDelivered && !item?.orderWithAddress?.order?.isReturnToWhsScanned) || [];
        if (!returnToWarehouse.length) return;
        const formattedData = returnToWarehouse.map(item => {
            const exceptionReasonCode = item.orderWithAddress?.order?.exceptionReasonCode;
            const exceptionReason = exceptionDictionaries.find(
                action => action.exceptionReasonCode === exceptionReasonCode
            );

            return{
                trackingNumber: item.trackingNumber,
                value: exceptionReason ? getExceptionTypeText(exceptionReason) : '',
            };
        });
        setReturnToWarehouseData(formattedData);
    }, [deliveringTasks])

    return (
        <TrackingTable
            title={TrackingTableTitle.RETURN_TO_WHS}
            data={returnToWarehouseData}
            tableRows={[t('pages.delivery.detail.trackingNumber'), t('pages.delivery.task.returnToWarehouse.failedReason')]}
        />
    );
};

export default ReturnToWarehousePage;
